
export default {
  data() {
    return {
      st: this.$store.state.settings.contents[this.$i18n.locale],
    }
  },
}
